import { User } from './user';

export class OperatorDocumentActivity {
  status: string = null;
  date: Date;
  user: User = null;
}
